import React from "react";
import style from "../assets/css/components/Loading.module.css";

function Loading() {
  return (
    <div className={style.container}>
        <p className={style.letter}>deportiv</p>
        <p className={style.letter}>istmo</p>
    </div>
  );
}

export default Loading;
